import React, {useEffect, useState} from 'react';
import {getStartEnd, getUsers} from '../../../services/MadricService';
import CheckinView from './CheckinView';
import {useNavigate} from 'react-router';
import {getHeuresSemaine} from '../../../services/MadricService';
import BankTable from './BankTable';
import '../CheckinView.css';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faArrowUp} from '@fortawesome/free-solid-svg-icons';
import NothingToDisplay from '../../NothingToDisplay';
import {useLocation} from 'react-router-dom';
import Spinner from '../../Spinner/Spinner';

/**
 * Gère les checkins
 * @return {JSX}
 */
function Checkin() {
  const navigate = useNavigate();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const [selectedUser, setSelectedUser] = useState({value: localStorage.getItem('id'), label: localStorage.getItem('name')});

  // Contient la liste de toutes les valeur des checkins
  const [startend, setStartend] = useState([]);

  // Permet de display ou non le graphique
  const [checkedGraph, setCheckedGraph] = useState(false);

  const [banque, setBanque] = useState({});
  const [week, setWeek] = useState(0);
  const [users, setUsers] = useState([]);

  useEffect(() => {
    const weekLocation = location.state === null ? 0 : location.state.week;
    setWeek(weekLocation);
    fetchData(weekLocation);
  }, []);

  const fetchData = async (weekPage) => {
    try {
      setIsLoading(true);
      await Promise.all([
        fetchWeekInfo(weekPage, selectedUser.value),
        fetchStartendInfo(weekPage, selectedUser.value),
        fetchUser(),
      ]);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchDataWhileOnPage = async (user) => {
    setSelectedUser(user);
    try {
      setIsLoading(true);
      await Promise.all([
        fetchWeekInfo(week, user.value),
        fetchStartendInfo(week, user.value),
      ]);
    } finally {
      setIsLoading(false);
    }
  };

  /**
   * Permet d'allez chercher les informations de la semaines
   * @param {*} numberweek la semaine
   * @param {*} user user
   */
  async function fetchWeekInfo(numberweek, user) {
    const res = await getHeuresSemaine(numberweek, user);
    setBanque(res.hoursBank);
  }

  /**
   * Permet d'allez chercher la liste des checkins de la semaines
   * @param {*} numberweek la semaine
   * @param {*} user user
   */
  async function fetchStartendInfo(numberweek, user) {
    const res = await getStartEnd(numberweek, user);
    setStartend(res);
  }

  /**
   * Va chercher la liste de users
   */
  async function fetchUser() {
    const res = await getUsers();
    setUsers(res);
  }

  const handleCheckedGraph = () => {
    setCheckedGraph(!checkedGraph);
  };

  // Navigue a la page pour update un checkin en passang en param (state) toute les valeur du checkin
  const handleUpdate = (id, startend) => {
    startend.navigate = 'checkin';
    navigate('/checkin/' + id, {state: {startend, week}});
  };

  const handleAdd = () => {
    navigate('/AddCheckin', {state: {week}});
  };

  const previous = () => {
    setWeek((prev) => prev + 1);
    fetchData(week + 1);
  };

  const next = () => {
    setWeek((prev) => prev - 1);
    fetchData(week - 1);
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };


  return (
    <div style={{overflow: 'hidden'}}>
      {isLoading && <Spinner />}
      <BankTable banque={banque} previous={previous} next={next} week={week} setWeek={setWeek} users={users} setSelectedUser={setSelectedUser} selectedUser={selectedUser} fetchDataWhileOnPage={fetchDataWhileOnPage} fetchData={fetchData}/>
      <div style={{textAlign: 'center', marginTop: '10px', marginBottom: '10px'}}>
        {startend.length !== 0 ?
      <React.Fragment>
        <label className="checkin-toggle-switch-label">Voir graphique ?</label>
        <div className="toggle-switch checkin-toggle-switch" >
          <div>
            <input
              id="toggle"
              type="checkbox"
              checked={checkedGraph}
              onChange={handleCheckedGraph} />
            <label htmlFor="toggle"></label>
          </div>
          <div>
          </div>
        </div>
      </React.Fragment>: ''}
        <div className="checkin-wrapper">
          <button className="float-end checkin-pagination-button checkin-button-add" onClick={() => handleAdd()}>Ajouter</button>
        </div>
      </div>
      {startend.length === 0 ? <NothingToDisplay /> : startend.map((s) => (
        <CheckinView key={s.id} startend={s} checkedGraph={checkedGraph} handleUpdate={handleUpdate} week={week}/>
      ))}
      {startend.length === 0 ? '' :<button className="checkin-scroll-to-top-button" onClick={scrollToTop}>
        <FontAwesomeIcon icon={faArrowUp}></FontAwesomeIcon>
      </button>}
    </div>
  );
}

export default Checkin;
